var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "调价",
        width: "440px",
        "close-on-click-modal": false,
        "show-close": true,
        "custom-class": "goods-price-adjust-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "dialog-body" }, [
        _c("div", { staticClass: "goods-info" }, [
          _c(
            "div",
            { staticClass: "goods-img" },
            [
              _vm.currentRow && _vm.currentRow.imagePath
                ? _c("el-image", {
                    staticClass: "img-el",
                    attrs: { src: _vm.currentRow.imagePath, fit: "cover" },
                  })
                : _c("div", { staticClass: "img-placeholder" }, [
                    _vm._v("暂无图片"),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "goods-detail" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.currentRow
                      ? _vm.currentRow.skuName || "--"
                      : "--",
                    placement: "top",
                    "open-delay": 300,
                  },
                },
                [
                  _c("div", { staticClass: "goods-name text-ellipsis" }, [
                    _vm._v(
                      _vm._s(
                        _vm.currentRow ? _vm.currentRow.skuName || "--" : "--"
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "goods-sku" }, [
                _vm._v(
                  "商品编号：" +
                    _vm._s(_vm.currentRow ? _vm.currentRow.skuId : "--")
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "price-info" }, [
          _c("div", { staticClass: "price-row" }, [
            _c("span", { staticClass: "price-label" }, [_vm._v("结算价")]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value" }, [
              _vm._v(
                "¥" +
                  _vm._s(
                    _vm.currentRow
                      ? _vm.currentRow.sellPrice != null
                        ? _vm.currentRow.sellPrice
                        : "--"
                      : "--"
                  )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "price-row" }, [
            _c("span", { staticClass: "price-label" }, [_vm._v("当前售价")]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value highlight" }, [
              _vm._v(
                "¥" +
                  _vm._s(
                    _vm.currentRow
                      ? _vm.currentRow.salePrice != null
                        ? _vm.currentRow.salePrice
                        : "--"
                      : "--"
                  )
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "adjust-section" }, [
          _c("div", { staticClass: "adjust-type-row" }, [
            _c("span", { staticClass: "form-label" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _vm._v("调价方式"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-control" },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.form.adjustType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "adjustType", $$v)
                      },
                      expression: "form.adjustType",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "none" } }, [
                      _vm._v("不调价"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: "ratio" } }, [
                      _vm._v("按比例调价"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.adjustType === "ratio",
                  expression: "form.adjustType === 'ratio'",
                },
              ],
              staticClass: "ratio-row",
            },
            [
              _c("span", { staticClass: "form-label" }, [
                _c("span", { staticClass: "required" }, [_vm._v("*")]),
                _vm._v("调价比例"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-control" },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "ratio-input",
                      attrs: { placeholder: "请输入", clearable: "" },
                      on: { input: _vm.handleRatioInput },
                      model: {
                        value: _vm.form.adjustRatio,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adjustRatio", $$v)
                        },
                        expression: "form.adjustRatio",
                      },
                    },
                    [
                      _c("template", { slot: "suffix" }, [
                        _c("span", { staticClass: "unit" }, [_vm._v("%")]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "根据商品山姆价调价，下调为负数，上调为正数，值范围-100到100，支持小数，保留两位小数"
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }